import graphql__b1af5bb751c5f2e193f9 from "./__generated__/AuthenticationFranceConnectForm_franceConnectAuth.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import { useAppContainerProps } from "../AppContainer";
import ButtonLink from "../Buttons/ButtonLink";

// FranceConnect mandates the explanatory text above the button and the
// "Qu'est-ce que FranceConnect ?" link below it, pointing to this exact URL.
const FRANCE_CONNECT_HELP_URL = "https://franceconnect.gouv.fr/";

const AuthenticationFranceConnectForm = props => {
  const franceConnectAuth = useFragment(
    AuthenticationFranceConnectForm_franceConnectAuth,
    props.franceConnectAuth
  );
  const { signInUrl } = franceConnectAuth;

  const t = useFormatMessage();
  const explanation = t(intlMessages.explanation);
  const buttonLabel = t(intlMessages.buttonLabel);
  const helpLink = t(intlMessages.helpLink);

  const { assets } = useAppContainerProps();
  const { franceConnectButtonUrl, franceConnectButtonHoverUrl } = assets;

  const className = classNames("form-wrapper", "france-connect", props.className);

  return (
    <div className={className} data-france-connect-auth-form>
      <p className="france-connect-explanation">{explanation}</p>

      <ButtonLink
        href={signInUrl}
        target="_self"
        type="button"
        className="france-connect-button"
        data-choose-france-connect-button
      >
        <img
          src={franceConnectButtonUrl}
          alt={buttonLabel}
          className="france-connect-button-image"
        />
        <img
          src={franceConnectButtonHoverUrl}
          alt={buttonLabel}
          aria-hidden="true"
          className="france-connect-button-image-hover"
        />
      </ButtonLink>

      <a
        href={FRANCE_CONNECT_HELP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="france-connect-help-link"
      >
        {helpLink}
      </a>
    </div>
  );
};

/* prettier-ignore */
const AuthenticationFranceConnectForm_franceConnectAuth = graphql__b1af5bb751c5f2e193f9;

export default AuthenticationFranceConnectForm;

const intlMessages = defineMessages({
  explanation: {
    id: "authentication.franceConnect.explanation",
    defaultMessage:
      "FranceConnect est la solution proposée par l'État pour sécuriser et " +
      "simplifier la connexion à vos services en ligne."
  },
  buttonLabel: {
    id: "authentication.franceConnect.button",
    defaultMessage: "S'identifier avec FranceConnect"
  },
  helpLink: {
    id: "authentication.franceConnect.help",
    defaultMessage: "Qu'est-ce que FranceConnect ?"
  }
});
